/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { caseInsensitiveComparator } from '../../../Display/NDC/utility/tableHeads';
import { dateComparator } from '../../Manufacturer/components/gridComponents/tableHead';

export const drugFamilyHead = [
  {
    headerName: 'Drug Family ID',
    field: 'familySeqNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,

    cellRenderer: 'FullNameRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const drugManufacturerHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const drugSpecificTherapeuticHead = [
  {
    headerName: 'Specific Therapeutic Class',
    field: 'specificTheraClass',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'shortDescription',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const labelerHead = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    comparator: caseInsensitiveComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDCTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellRenderer: 'ndc',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_160,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const MarketBasketHead = [
  {
    headerName: 'Market Basket ID',
    field: 'marketBasketSeqNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellRenderer: 'marketBasketSeqNum',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Basket Name',
    field: 'marketBasketName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'marketBasketName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const PopupMarketBasketHead = [
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellRenderer: 'familyName',
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'startDt',
    cellEditor: MaxLengthNumericEditor,
    comparator: dateComparator,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'endDt',
    comparator: dateComparator,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Basket ID',
    field: 'marketBasketSeqNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'marketBasketSeqNum',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const PopupManufacturerHead = [
  {
    headerName: 'Family ID',
    field: 'familySeqNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellRenderer: 'familySeqNum',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    dataAlignRight: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'familyName',
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Width_280,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Brand Name',
    field: 'brandName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    cellRenderer: 'brandName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Mfg ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'mfgId',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const PopupTherapeuticHead = [
  {
    headerName: 'Family ID',
    field: 'familySeqNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellRenderer: 'familySeqNum',
    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'familyName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Brand Name',
    field: 'brandName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    cellRenderer: 'brandName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Specific Therapeutic Class',
    field: 'specificTheraClass',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'specificTheraClass',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const detailsDrugTab = [
  {
    headerName: 'Comments Exists',
    field: 'cc_COMMENTS_EXIST',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    cellEditor: MaxLengthNumericEditor,
    maxWidth: Styles.Width_180,
    minWidth: Styles.Width_150,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action frr-overflow-visible',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'IconButtonCell',
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],

    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'FullNameRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    comparator: dateComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'DatePickerBoxRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    comparator: dateComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'DatePickerBoxRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const MarketBasketTab = [
  {
    headerName: 'Market Basket',
    field: 'marketBasketName',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    cellRenderer: 'ndc',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    cellRenderer: 'drugName',
    comparator: dateComparator,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    cellRenderer: 'drugName',
    comparator: dateComparator,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Description',
    field: 'marketBasketDescr',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
];

export const ContractTab = [
  {
    headerName: 'Contract ID',
    field: 'contractName',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'FullNameRender',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_250,
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_180,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Mfg ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_135,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Basket Name',
    field: 'marketBasketName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_210,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Pricing Method',
    field: 'rebatePricingMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_230,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Share Calculation Method',
    field: 'mktShareCalcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_290,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Volume Calc Method',
    field: 'volumeCalcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_215,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    comparator: dateComparator,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellEditor: MaxLengthNumericEditor,
    comparator: dateComparator,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDCDetailTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    minWidth: 150,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'FullNameRender',
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',
    minWidth: 150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
